import { NavLink } from "react-router-dom";
import styledComponents from "styled-components";

const NavigationLink = styledComponents(NavLink)`
  font-size: ${({ theme, footer }) => footer ? theme.fontSizes.p : theme.fontSizes.h5};
  text-decoration: none;
  color: ${({ theme, footer }) => footer ? theme.colors.white : theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  transition: all 0.3s ease-in-out;
  position: relative;

  &:hover, &:focus, &:active, &.active {
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    color: ${({ theme, footer }) => footer ? theme.colors.secondary : theme.colors.primary};

    &:after {
      content: "";
      position: absolute;
      bottom: -0.5rem;
      left: 0;
      width: 20px;
      height: 2px;
      background: ${({ theme, footer }) => footer ? "none" : theme.colors.secondary};
    }
  }
`

export default NavigationLink;